/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CancelPaymentResponse,
  CancelTopUpPaymentRequest,
  CompletePaymentResponse,
  CompleteTopUpPaymentRequest,
  ExecutePaymentResponse,
  ExecuteTopUpPaymentRequest,
  PreparePaymentResponse,
  PrepareTopUpPaymentRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiTopUpPaymentController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-top-up-payment-controller
   * @name PreparePayment
   * @request POST:/api/v1/top-ups/payments/prepare
   */
  preparePayment = (data: PrepareTopUpPaymentRequest, params: RequestParams = {}) =>
    this.http.request<PreparePaymentResponse, any>({
      path: `/v1/top-ups/payments/prepare`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static preparePaymentPath = '/v1/top-ups/payments/prepare'
  static preparePaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-top-up-payment-controller
   * @name ExecutePayment
   * @request POST:/api/v1/top-ups/payments/execute
   */
  executePayment = (data: ExecuteTopUpPaymentRequest, params: RequestParams = {}) =>
    this.http.request<ExecutePaymentResponse, any>({
      path: `/v1/top-ups/payments/execute`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static executePaymentPath = '/v1/top-ups/payments/execute'
  static executePaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-top-up-payment-controller
   * @name CompletePayment
   * @request POST:/api/v1/top-ups/payments/complete
   */
  completePayment = (data: CompleteTopUpPaymentRequest, params: RequestParams = {}) =>
    this.http.request<CompletePaymentResponse, any>({
      path: `/v1/top-ups/payments/complete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static completePaymentPath = '/v1/top-ups/payments/complete'
  static completePaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-top-up-payment-controller
   * @name CancelPayment
   * @request POST:/api/v1/top-ups/payments/cancel
   */
  cancelPayment = (data: CancelTopUpPaymentRequest, params: RequestParams = {}) =>
    this.http.request<CancelPaymentResponse, any>({
      path: `/v1/top-ups/payments/cancel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static cancelPaymentPath = '/v1/top-ups/payments/cancel'
  static cancelPaymentMethod = 'POST'
}
